var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRegistryManagement(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.25 10.5C12.25 10.8094 12.1271 11.1062 11.9083 11.325C11.6895 11.5438 11.3928 11.6667 11.0833 11.6667H2.91667C2.60725 11.6667 2.3105 11.5438 2.09171 11.325C1.87292 11.1062 1.75 10.8094 1.75 10.5V3.5C1.75 3.19058 1.87292 2.89383 2.09171 2.67504C2.3105 2.45625 2.60725 2.33333 2.91667 2.33333H5.83333L7 4.08333H11.0833C11.3928 4.08333 11.6895 4.20625 11.9083 4.42504C12.1271 4.64383 12.25 4.94058 12.25 5.25V10.5Z",
    stroke: "#8E8E8E",
    strokeWidth: 0.875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRegistryManagement);
export default __webpack_public_path__ + "static/media/RegistryManagement.e3fe26d899f43d278262b05b66dca7ad.svg";
export { ForwardRef as ReactComponent };